import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface AreYouSureInfo {
  title?: string;
  description?: string;
  warning?: string;
  continueBtn?: {
    color?: string;
    text?: string;
    class?: string;
  };
  cancelBtn?: {
    color?: string;
    text?: string;
    class?: string;
  };
}

@Component({
  selector: "app-are-you-sure-dialog",
  templateUrl: "./are-you-sure-dialog.component.html",
  styleUrls: ["./are-you-sure-dialog.component.scss"],
})
export class AreYouSureDialogComponent implements OnInit {
  areYouSureInfo!: AreYouSureInfo;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { areYouSureInfo: AreYouSureInfo },
  ) {}

  ngOnInit(): void {
    const defaultObj: AreYouSureInfo = {
      title: "Are you sure?",
      description: "You are about to delete this condition.",
      continueBtn: {
        color: "warn",
        text: "Continue",
      },
      cancelBtn: {
        color: "lightGrey",
        text: "Cancel",
      },
    };

    this.areYouSureInfo = { ...defaultObj, ...this.data.areYouSureInfo };
  }
}
